import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _CloudRainIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M9.50012 0.0143373C5.59006 -0.20584 1.98643 2.12775 0.587725 5.78571C-0.810985 9.44368 0.316325 13.5862 3.37576 16.031C3.80721 16.3758 4.43647 16.3055 4.78124 15.8741C5.12601 15.4426 5.05574 14.8134 4.62429 14.4686C2.24473 12.5671 1.36793 9.3451 2.45582 6.50002C3.5437 3.65494 6.34652 1.83992 9.38768 2.01117C12.4288 2.18242 15.0102 4.30062 15.7718 7.24985C15.8858 7.69135 16.284 7.99981 16.74 7.99981H17.9992C19.8914 8.00222 21.523 9.33011 21.9097 11.1824C22.2964 13.0347 21.3322 14.9047 19.5988 15.6638C19.093 15.8854 18.8625 16.4751 19.084 16.981C19.3056 17.4869 19.8953 17.7174 20.4012 17.4958C23.0012 16.3571 24.4476 13.5522 23.8675 10.7736C23.2874 7.99508 20.8397 6.00315 18.0012 5.99981H17.4795C16.2801 2.60299 13.1473 0.21971 9.50012 0.0143373Z"
        fill={iconColor}
      />
      <Path
        d="M9 12.9998C9 12.4475 8.55229 11.9998 8 11.9998C7.44772 11.9998 7 12.4475 7 12.9998V20.9998C7 21.5521 7.44772 21.9998 8 21.9998C8.55229 21.9998 9 21.5521 9 20.9998V12.9998Z"
        fill={iconColor}
      />
      <Path
        d="M17 12.9998C17 12.4475 16.5523 11.9998 16 11.9998C15.4477 11.9998 15 12.4475 15 12.9998V20.9998C15 21.5521 15.4477 21.9998 16 21.9998C16.5523 21.9998 17 21.5521 17 20.9998V12.9998Z"
        fill={iconColor}
      />
      <Path
        d="M12 13.9998C12.5523 13.9998 13 14.4475 13 14.9998V22.9998C13 23.5521 12.5523 23.9998 12 23.9998C11.4477 23.9998 11 23.5521 11 22.9998V14.9998C11 14.4475 11.4477 13.9998 12 13.9998Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const CloudRainIcon = assignWithoutSideEffects(_CloudRainIcon, {
  componentId: 'CloudRainIcon',
});

export default CloudRainIcon;
